<mat-dialog-content>
  <h1 matDialogTitle class="h1-title">
    {{ "CREATE_COMBO_DYNAMIC.TITLE" | translate }}
  </h1>

  <div
    [formGroup]="form"
    (keyup.enter)="form.valid && !loading ? onCreateComboDynamic() : null"
    class="mt-8 create-client-width flex-column-center-start"
  >
    <mat-form-field class="item-full-width fxFlex-100p">
      <mat-label>{{ "GENERIC.EXTERNAL_NAME" | translate }}</mat-label>
      <input
        matInput
        class="fxFlex-100p"
        formControlName="name"
        autocomplete="nope"
        type="text"
        [(ngModel)]="product.name"
        required
      />
      <mat-error *ngIf="form.controls['name'].invalid">{{
        "GENERIC.INPUT_LENGTH_INVALID" | translate
      }}</mat-error>
    </mat-form-field>

    <mat-form-field class="item-full-width">
      <mat-label>{{
        "CREATE_COMBO_DYNAMIC.SELECT_TYPE" | translate
      }}</mat-label>
      <mat-select [(value)]="product.invoice_category" class="">
        <mat-option [value]="'FOOD'">{{
          "CREATE_COMBO_DYNAMIC.FOOD" | translate
        }}</mat-option>
        <mat-option [value]="'DRINK'">{{
          "CREATE_COMBO_DYNAMIC.DRINK" | translate
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="loading" class="flex-row-center-start">
    <mat-spinner [diameter]="40" class="mt-20"></mat-spinner>
  </div>

  <div
    mat-dialog-actions
    class="mt-12 gt2-buttons-theme flex-row-center-center"
  >
    <button
      mat-raised-button
      [disabled]="!form.valid || loading"
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onCreateComboDynamic()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="dialogRef.close(false)"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </div>
</mat-dialog-content>
